import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Switch from '@material-ui/core/Switch';

const PaymentDetails = () => {
  return (
    <PaymentDetailsPane></PaymentDetailsPane>
  );
};

const PaymentDetailsPane = () => {
  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "3rem",
        marginBottom: "50vh",
        overflow: "hidden",
      }}
    >
      <div>
        <h5 class="px-2" style={{fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",}}>When ready, you will be able to review payment here, update payment details etc. This is in development and we will get it ready for you soon. Thanks for your patience.</h5>
      </div>
    </div>
  );
};

export default PaymentDetails;
